<template>
  <template
    v-for="(packing_list_format, idx) in packing_list_formats"
    :key="idx"
  >
    <button
      type="button"
      @click.prevent="downloadPackingListXlsx(packing_list_format)"
      class="btn-white"
    >
      <i
        :class="[
          'fa-solid',
          packing_list_format.downloading ? 'fa-sync fa-spin' : 'fa-file-excel'
        ]"
      ></i>
      <span class="space-icon"></span>{{ packing_list_format.name }}
    </button>
    <span class="space-actions" />
  </template>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/show_container.js";

export default {
  name: "TabsDownloadButtonsPackingList",
  data() {
    return {
      packing_list_formats: []
    };
  },
  props: {
    packing_house_id: {
      required: true
    },
    container_id: {
      required: true
    },
    container_code: {
      required: true
    }
  },
  methods: {
    fetchPackingListFormats: async function () {
      let response = await Requester.fetchPackingListFormats(this.packing_house_id, this.container_id);
      this.packing_list_formats = response.data;

      this.packing_list_formats.forEach(packing_list_format => {
        packing_list_format["downloading"] = false;
      });
    },
    downloadPackingListXlsx: async function (packing_list_format) {
      packing_list_format.downloading = true;
      try {
        let response = await Requester.downloadPackingListXlsx(
          this.packing_house_id,
          this.container_id,
          packing_list_format.id
        );
        const file = response.data;
        this.downloadFile(file, `PackingList-${this.container_code}.xlsx`)
      } catch (error) {
        error;
      }
      packing_list_format.downloading = false;
    }
  },
  created() {
    this.fetchPackingListFormats();
  }
};
</script>
